import { useParams } from 'react-router-dom';

import RundownFormContainer from './index';

/**
 * Wrapper component that extracts route params and passes them to the connected RundownForm container
 * This bridges React Router v6's useParams() hook with the legacy connect() HOC pattern
 */
const RundownFormWithParams = () => {
  const params = useParams();

  return <RundownFormContainer params={params} />;
};

export default RundownFormWithParams;
